import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import * as Sentry from '@sentry/angular-ivy';
import { setGlobalDateHandling } from 'app/core/services';
import { sentryIgnore } from 'app/core/services/error-handler';
import { NamingConvention } from 'breeze-client';
import { environment } from 'environments/environment';

// guidance: https://docs.sentry.io/platforms/react-native/performance/instrumentation/automatic-instrumentation/
Sentry.init({
  dsn: 'https://b05d0c01fd4b43bb882a8f6e48c31e36@o4504019471368192.ingest.sentry.io/4504046313078784',
  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysOnErrorSampleRate: environment.replaysOnErrorSampleRate,
  integrations: [
    new Sentry.Replay(),
    new Sentry.BrowserTracing({
      // Do not create spans for outgoing requests to a localhost or ping endpoints
      shouldCreateSpanForRequest: (url) => environment.sendToSentry,
      tracePropagationTargets: [location.hostname, environment.apiRoot, /^\//],
      routingInstrumentation: Sentry.routingInstrumentation,
    }),
  ],
  environment: environment.production ? 'production' : 'development',
  beforeSend: (event, hint) => (!sentryIgnore(event, hint) ? event : null),

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: environment.traceSampleRate,
  // Capture Replay for 10% of all sessions,
  // replaysSessionSampleRate: 0.1,
});

// Configure date handling
setGlobalDateHandling({ parseUtcAsLocalDate: true });

// Configure naming convention. Needs to be configured here to be in place for the auth calls
NamingConvention.camelCase.setAsDefault();

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
